import React from 'react';

// helpers
import {useTheme} from '@emotion/react';
import {useTranslation} from 'react-i18next';
import {formatCurrency} from '../../helpers';

// components
import {Link} from 'react-router-dom';
import {Button} from '@mui/joy';

// styles
import {
  TableWrapper,
  TableHeaderItem,
  ActionColumnHeaderItem,
  TableRow,
  ClickableTableCell,
  StyledLink,
  ActionButtonWrapper,
} from './Table-styles';
import {IconRightArrow, TextDefault, TextSmall} from '../../styles';

// types
import {Subscription} from '../../services/ApiService/types';

type Props = {
  subscriptions: Subscription[];
};

const TableSubscriptions = ({subscriptions}: Props) => {
  const {t} = useTranslation();
  const theme = useTheme();

  return (
    <TableWrapper borderAxis="none">
      <thead>
        <tr>
          <TableHeaderItem>
            <TextDefault bold="bold">
              {t('subscription_subscriptionNumber')}
            </TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">{t('global_date')}</TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">{t('global_status')}</TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">{t('subscription_amount')}</TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">{t('global_totalOwing')}</TextDefault>
          </TableHeaderItem>
          <ActionColumnHeaderItem />
        </tr>
      </thead>
      <tbody>
        {subscriptions.map((subscription) => {
          const navigationPath = `/subscriptions/${subscription.id}`;
          return (
            <TableRow key={subscription.id}>
              <ClickableTableCell>
                <StyledLink to={navigationPath}>
                  <TextSmall>#{subscription.subscriptionNumber}</TextSmall>
                </StyledLink>
              </ClickableTableCell>
              <ClickableTableCell>
                <StyledLink to={navigationPath}>
                  <TextSmall>{subscription.startDate}</TextSmall>
                </StyledLink>
              </ClickableTableCell>
              <ClickableTableCell>
                <StyledLink to={navigationPath}>
                  <TextSmall>{subscription.status}</TextSmall>
                </StyledLink>
              </ClickableTableCell>
              <ClickableTableCell>
                <StyledLink to={navigationPath}>
                  <TextSmall>{formatCurrency(subscription.amount)}</TextSmall>
                </StyledLink>
              </ClickableTableCell>
              <ClickableTableCell>
                <StyledLink to={navigationPath}>
                  <TextSmall>
                    {formatCurrency(subscription.totalOwing)}
                  </TextSmall>
                </StyledLink>
              </ClickableTableCell>
              <ActionButtonWrapper>
                <Button
                  style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: theme.border.radius.xxs,
                  }}
                  variant="outlined"
                  endDecorator={<IconRightArrow />}
                  component={Link}
                  to={navigationPath}>
                  {t('global_details')}
                </Button>
              </ActionButtonWrapper>
            </TableRow>
          );
        })}
      </tbody>
    </TableWrapper>
  );
};

export default TableSubscriptions;
